import { Container, Row } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-7">
        <Container fluid>
          <div className="header-body">
            <Row></Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
